/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Level_2Inputs */

const en_statement_taxonomy_editor_level_2 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level 2`)
};

const nl_statement_taxonomy_editor_level_2 = /** @type {(inputs: Statement_Taxonomy_Editor_Level_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau 2`)
};

/**
* | output |
* | --- |
* | "Level 2" |
*
* @param {Statement_Taxonomy_Editor_Level_2Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_level_2 = /** @type {((inputs?: Statement_Taxonomy_Editor_Level_2Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Level_2Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_level_2(inputs)
	return en_statement_taxonomy_editor_level_2(inputs)
});